import { Star } from "lucide-react";

const Vacante = () => (
  <span className="rounded-full bg-coral/20 px-2 py-0.5 font-mono text-[9px] font-semibold uppercase tracking-widest text-coral">
    Vacante
  </span>
);

export const MainSponsor = ({ variant = "slot", theme = "dark", label }) => {
  const isDark = theme === "dark";
  const fg = isDark ? "#F7F9F6" : "#2D3436";

  const Mark = ({ size = "h-8 w-8", bg = "bg-gold" }) => (
    <span className={`flex ${size} items-center justify-center rounded-lg ${bg}`}>
      <Star className="h-4 w-4 text-ink" fill="#2D3436" />
    </span>
  );

  if (variant === "bug") {
    return (
      <div className="fixed bottom-4 left-4 z-40" data-testid="main-sponsor-bug">
        <div className="flex items-center gap-2.5 rounded-2xl bg-ink/90 px-3.5 py-2.5 text-cream shadow-[0_10px_30px_rgba(0,0,0,0.25)] ring-1 ring-white/10 backdrop-blur-md">
          <Mark />
          <div className="leading-none">
            <div className="font-mono text-[8px] uppercase tracking-[0.25em] text-cream/50">
              Patrocinador principal
            </div>
            <div className="mt-1 flex items-center gap-2">
              <span className="font-display text-sm font-extrabold tracking-tight">
                SPONSOR MAIN
              </span>
              <Vacante />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (variant === "inline") {
    return (
      <div
        className="inline-flex items-center gap-2 rounded-full bg-gold/20 px-3 py-1.5"
        data-testid="main-sponsor-inline"
      >
        <Mark size="h-5 w-5" />
        <span
          className="font-mono text-[10px] uppercase tracking-[0.2em]"
          style={{ color: fg }}
        >
          Presenta · SPONSOR MAIN
        </span>
        <Vacante />
      </div>
    );
  }

  if (variant === "cobranding") {
    return (
      <button
        type="button"
        data-testid="sponsor-cobranding"
        className="group inline-flex items-center gap-3 rounded-full bg-mint px-5 py-3 text-ink transition-all hover:-translate-y-0.5"
      >
        <Mark size="h-7 w-7" bg="bg-white/70" />
        <span className="text-left leading-none">
          <span className="block font-mono text-[8px] uppercase tracking-[0.25em] text-ink/50">
            Patrocinador
          </span>
          <span className="mt-1 flex items-center gap-2">
            <span className="font-display text-sm font-extrabold tracking-tight">
              {label || "CO-BRANDING"}
            </span>
            <Vacante />
          </span>
        </span>
      </button>
    );
  }

  if (variant === "naming") {
    return (
      <div
        className="relative select-none"
        style={{ width: 128, height: 128 }}
        data-testid="sponsor-naming"
      >
        <svg viewBox="0 0 128 128" width="128" height="128">
          <defs>
            <path
              id="naming-path"
              d="M64,64 m-48,0 a48,48 0 1,1 96,0 a48,48 0 1,1 -96,0"
              fill="none"
            />
          </defs>
          <circle cx="64" cy="64" r="60" fill="none" stroke="#E8C547" strokeWidth="2" strokeDasharray="4 5" />
          <circle cx="64" cy="64" r="50" fill="none" stroke="#E8C547" strokeWidth="2" />
          <text
            fill="#E8C547"
            style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: "9.5px", fontWeight: 600, letterSpacing: "1.5px" }}
          >
            <textPath href="#naming-path" startOffset="0%">
              PATROCINADOR · NAMING · VACANTE ·&nbsp;
            </textPath>
          </text>
          <text
            x="64"
            y="60"
            textAnchor="middle"
            fill="#E8C547"
            style={{ fontFamily: "'Bricolage Grotesque', sans-serif", fontSize: "18px", fontWeight: 800 }}
          >
            NAMING
          </text>
          <text
            x="64"
            y="80"
            textAnchor="middle"
            fill={fg}
            style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: "9px", fontWeight: 600, letterSpacing: "2px" }}
          >
            VACANTE
          </text>
        </svg>
      </div>
    );
  }

  // slot (SPONSOR MAIN)
  return (
    <div
      className="inline-flex items-center gap-4 rounded-2xl border-2 border-dashed px-6 py-4"
      style={{ borderColor: fg + "33" }}
      data-testid="main-sponsor-slot"
    >
      <Mark size="h-10 w-10" />
      <div className="leading-none">
        <div
          className="font-mono text-[9px] uppercase tracking-[0.3em]"
          style={{ color: fg, opacity: 0.5 }}
        >
          Patrocinador principal
        </div>
        <div className="mt-1.5 flex items-center gap-2">
          <span
            className="font-display text-xl font-extrabold tracking-tight"
            style={{ color: fg }}
          >
            {label || "SPONSOR MAIN"}
          </span>
          <Vacante />
        </div>
      </div>
    </div>
  );
};
